import { utils } from '@yola/ws-sdk';

const isSameOrigin = (url) => {
  try {
    if (!utils.hasUrlOrigin(url)) {
      return false;
    }

    const targetUrl = new URL(url, window.location.href);
    return window.location.origin === targetUrl.origin;
  } catch (e) {
    return false;
  }
};

export default isSameOrigin;
